import { Link } from "react-router-dom";
import AppLayout from "../components/AppLayout";

/**
 * Home / landing page. Structure inspired by the SMS portal home screen
 * (welcome + section headings + bulleted feature lists + See Also panel).
 * Content is written specifically for this CoS Creator product.
 */
export default function Home() {
  const user = JSON.parse(localStorage.getItem("cos_user") || "null");
  const displayName = user?.name || "there";

  return (
    <AppLayout
      activeMenu="home"
      breadcrumb={[
        { label: "Sponsorship management system", to: "/" },
        { label: "Home" },
      ]}
      seeAlso={[
        { label: "How to create a CoS", href: "#" },
        { label: "Sponsor duties overview", href: "#" },
        { label: "Accessibility statement", href: "#" },
        { label: "Cookie statement", href: "#" },
      ]}
    >
      <h1 data-testid="home-heading">Welcome, {displayName}</h1>
      <p>
        This portal lets you draft, review and issue Certificates of Sponsorship
        (CoS) for skilled workers. Choose a section below or use the menu on the
        left to jump to a specific task.
      </p>

      <h2 style={{ marginTop: 18 }}>
        <Link to="#" style={{ textDecoration: "underline" }}>
          Licence summary, applications and services
        </Link>
      </h2>
      <p style={{ margin: "4px 0 6px 0" }}>
        <Link to="#">Help</Link>
        {" — "}Licence summary, applications and services
      </p>
      <ul className="sms-bullets">
        <li>View your licence details, registered users and key dates</li>
        <li>Update your registered address and named contacts</li>
        <li>Request an increase to your annual CoS allocation</li>
        <li>Renew your annual CoS allocation</li>
        <li>Track the status of any applications you have submitted</li>
      </ul>

      <h2 style={{ marginTop: 18 }}>
        <Link to="/cos" style={{ textDecoration: "underline" }}>Workers</Link>
      </h2>
      <p style={{ margin: "4px 0 6px 0" }}>
        <Link to="/cos">Help</Link>{" — "}Workers
      </p>
      <ul className="sms-bullets">
        <li>
          <Link to="/cos/new" data-testid="home-link-create">Create and assign</Link>{" "}
          a new CoS with sponsor and job details
        </li>
        <li>
          <Link to="/cos" data-testid="home-link-view">View, edit or duplicate</Link>{" "}
          existing certificates and download the finished PDF
        </li>
        <li>Import an existing CoS PDF to reuse sponsor and job details</li>
        <li>Manage saved sponsors and job presets</li>
        <li>Track certificate status (Assigned, Ready to go, Used)</li>
      </ul>

      {user?.role === "admin" && (
        <>
          <h2 style={{ marginTop: 18 }}>
            <Link to="/admin/users" style={{ textDecoration: "underline" }}>
              Administration
            </Link>
          </h2>
          <p style={{ margin: "4px 0 6px 0" }}>
            <Link to="/admin/users">Help</Link>{" — "}Administration
          </p>
          <ul className="sms-bullets">
            <li>Approve or reject sign-up requests from new users</li>
            <li>Revoke access from previously approved users</li>
            <li>Delete users who no longer need access</li>
          </ul>
        </>
      )}
    </AppLayout>
  );
}
